<!-- ─────────── Catálogo ─────────── -->
<section class="pdv-catalogo" *ngIf="!produtoSelecionado">

  <div class="pv2-gd-banner is-mode-editar">
    <span class="pv2-gd-banner__icon">
      <span class="fa fa-shopping-cart"></span>
    </span>
    <span>Toque em um produto para escolher quantidade e adicionais.</span>
  </div>

  <div class="pdv-catalogo__toolbar">
    <label class="pv2-search">
      <span class="fa fa-search"></span>
      <input type="text" placeholder="Buscar produto (nome ou código)..."
             [(ngModel)]="buscaTermo" (input)="filtrarProdutos()">
    </label>

    <div class="pdv-catalogo__filter-row">
      <div class="pdv-catalogo__chips">
        <button type="button" class="pv2-chip"
                *ngFor="let cat of categorias"
                [class.is-active]="categoriaSelecionada?.id === cat.id"
                (click)="selecionarCategoria(cat)">
          {{cat.nome}}
        </button>
      </div>
      <span class="pdv-catalogo__count">{{produtosFiltrados.length}} itens</span>
    </div>
  </div>

  <div class="pdv-catalogo__grid" *ngIf="produtosFiltrados.length && !loading">
    <button type="button" class="pdv-produto-chip"
            *ngFor="let prod of produtosFiltrados"
            (click)="selecionarProduto(prod)">
      <span class="pdv-produto-chip__thumb" *ngIf="prod.imagens && prod.imagens.length > 0">
        <img [src]="'https://fibo.meucardapio.ai/images/empresa/' + prod.imagens[0].linkImagem" alt="{{prod.nome}}">
      </span>
      <span class="pdv-produto-chip__thumb pdv-produto-chip__thumb--empty" *ngIf="!prod.imagens || prod.imagens.length === 0">
        <span class="fa fa-image"></span>
      </span>
      <span class="pdv-produto-chip__name">{{prod.nome}}</span>
      <span class="pdv-produto-chip__price">
        {{ (prod.novoPreco ? prod.novoPreco : prod.preco) | currency:'BRL' }}
      </span>
    </button>
  </div>

  <div class="pdv-catalogo__loading" *ngIf="loading">
    <span class="fa fa-spinner fa-spin"></span> Carregando produtos...
  </div>

  <div class="pdv-empty" *ngIf="!produtosFiltrados.length && !loading">
    <h3>Nenhum produto encontrado</h3>
    <p>Ajuste a busca ou escolha outra categoria.</p>
  </div>
</section>

<!-- ─────────── Detalhes do produto (quantidade / adicionais) ─────────── -->
<section class="pdv-detalhe" *ngIf="produtoSelecionado">
  <header class="pdv-detalhe__header">
    <button type="button" class="pv2-icon-btn" (click)="cancelarSelecao()">
      <span class="fa fa-arrow-left"></span>
    </button>
    <div class="pdv-detalhe__title">
      <h3>{{produtoSelecionado.nome}}</h3>
      <span *ngIf="exibirUnidade(produtoSelecionado)">
        {{produtoSelecionado.preco | currency:'BRL'}} por KG
      </span>
    </div>
  </header>

  <div class="pdv-detalhe__body">
    <form>
      <ng-container *ngIf="!exibirUnidade(produtoSelecionado)">
        <div class="pdv-field">
          <span class="pdv-field__label">Quantidade</span>
          <div class="pdv-stepper">
            <button type="button" class="pdv-stepper__btn"
                    (click)="itemPedido.qtde = itemPedido.qtde - 1"
                    [disabled]="itemPedido.qtde <= 1">−</button>
            <input type="number" [(ngModel)]="itemPedido.qtde" name="qtde">
            <button type="button" class="pdv-stepper__btn"
                    (click)="itemPedido.qtde = itemPedido.qtde + 1">+</button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="exibirUnidade(produtoSelecionado)">
        <div class="pdv-field">
          <span class="pdv-field__label">Peso ({{produtoSelecionado.unidadeMedida?.sigla}})</span>
          <input type="number" class="pdv-field__input" [(ngModel)]="itemPedido.qtde" name="peso">
        </div>
      </ng-container>

      <div class="pdv-detalhe__adicionais" *ngIf="produtoSelecionado.tamanhos">
        <app-adicionais-customizados #adicionaisCustomizados
                                     (alterouTamanho)="onAlterouTamanho($event)"
                                     [itemPedido]="itemPedido"
                                     [produto]="produtoSelecionado">
        </app-adicionais-customizados>
      </div>

      <div class="pdv-detalhe__adicionais" *ngFor="let campoAdicional of produtoSelecionado.camposAdicionais">
        <app-site-campo-adicional #adicionalComponent
                                  [campoAdicional]="campoAdicional"
                                  [itemPedido]="itemPedido"
                                  [posicao]="campoAdicional.posicao"
                                  (onDesmarcouOpcao)="desmarcouNovaOpcao($event)"
                                  (onMarcouOpcao)="escolheuNovaOpcao($event)">
        </app-site-campo-adicional>
      </div>

      <div class="pdv-field pdv-field--stacked">
        <span class="pdv-field__label">Observação</span>
        <textarea rows="2" [(ngModel)]="itemPedido.observacao" name="obs"
                  placeholder="Ex: Sem cebola..."></textarea>
      </div>

      <div class="pdv-alert pdv-alert--danger" *ngIf="mensagemErro">{{mensagemErro}}</div>
    </form>
  </div>

  <footer class="pdv-detalhe__footer">
    <button type="button" class="pv2-ghost-btn" (click)="cancelarSelecao()">
      <span class="fa fa-arrow-left"></span>
      Voltar
    </button>
    <button type="button" class="pv2-primary-btn pdv-detalhe__submit"
            (click)="editando ? atualizeProduto() : adicionarProduto()">
      <span *ngIf="!editando">Adicionar</span>
      <span *ngIf="editando">Atualizar</span>
      <strong>{{ itemPedido.total | currency:'BRL' }}</strong>
    </button>
  </footer>
</section>
